"use strict";

require("core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/es.parse-int.js");
require("core-js/modules/es.array.concat.js");
var _react = require("react");
/**
 * React hook to make the unsreponsive video element responsive.
 * works for
 *  - iframe[src*='player.vimeo.com']
 *  - iframe[src*='youtube.com']
 *  - iframe[src*='youtube-nocookie.com']
 *
 * // test "iframe[src*='screencast.autodesk.com']"
 */

function useResponsiveVids() {
  (0, _react.useEffect)(function () {
    if (!document.getElementById('fit-vids-style')) {
      // appendStyles: https://github.com/toddmotto/fluidvids/blob/master/dist/fluidvids.js
      var head = document.head || document.getElementsByTagName('head')[0];
      var css = '.video-wrapper{width:100%;position:relative;padding:0;}.video-wrapper iframe,.video-wrapper object,.video-wrapper embed {position:absolute;top:0;left:0;width:100%;height:100%;}';
      var div = document.createElement('div');
      // eslint-disable-next-line no-unsafe-innerhtml/no-unsafe-innerhtml
      div.innerHTML = "<p>x</p><style id=\"fit-vids-style\"> ".concat(css, "</style>");
      head.appendChild(div.childNodes[1]);
    }

    // Video element selectors
    // you can extend this to other element whereever required.
    var selectors = ["iframe[src*='player.vimeo.com']", "iframe[src*='youtube.com']", "iframe[src*='youtube-nocookie.com']"];
    var allVidElements = document.querySelectorAll(selectors.join(','));
    allVidElements.forEach(function (vidEle) {
      if (!vidEle.parentElement.classList.contains('video-wrapper')) {
        var height = vidEle.clientHeight;
        if (vidEle.tagName.toLowerCase() === 'object' || vidEle.getAttribute('height') && parseInt(vidEle.getAttribute('height'), 10)) {
          height = parseInt(vidEle.getAttribute('height'), 10);
        }
        var width = parseInt(vidEle.getAttribute('width'), 10) ? parseInt(vidEle.getAttribute('width'), 10) : vidEle.width();
        var aspectRatio = height / width;
        vidEle.removeAttribute('height');
        vidEle.removeAttribute('width');
        var content = vidEle.outerHTML;
        var wrapEle = "<div class=\"video-wrapper\" style=\"padding-top: ".concat(aspectRatio * 100, "%\">").concat(content, "</div>");
        // eslint-disable-next-line no-param-reassign, no-unsafe-innerhtml/no-unsafe-innerhtml
        vidEle.outerHTML = wrapEle;
      }
    });
  }, []);
}
var _default = useResponsiveVids;
exports.default = _default;